import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import i18n from "i18next";

class HelpComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      updateLanguage: false,
    };
  }
  componentDidMount() {
    const { language } = this.props;
    this.setState({updateLanguage:true})
    i18n.changeLanguage(language)  
  }
  render() {
    return (
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12">
              <div className="card">
                <div className="header">
                  <h4 className="title">
                    {i18n.t("help")}
                  </h4>
                </div>
                <div className="content">
                  <p dangerouslySetInnerHTML={{__html: i18n.t('documentDownloadMessage',{"yardimPdf":`/${i18n.t(this.props.user.harcirahHelpFile)}.pdf`})}}></p>
                  <p className="p">
                    <br />
                    <iframe width="100%" title="harcirah" height="1000px" src={`/${i18n.t(this.props.user.harcirahHelpFile)}.pdf`} />
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  language: state.auth.language
});

export default withRouter(connect(mapStateToProps)(HelpComponent));



// WEBPACK FOOTER //
// ./src/pages/help/index.js